import { useAtom } from '@reatom/npm-react'
import { motion } from 'motion/react'
import styled, { css } from 'styled-components'

import { tradeOrderTypeAtom } from '@root/features/trade/trading'

import { TradingControlsBuyButton } from '../../common/trading-controls-buy/trading-controls-buy-button'
import { TradingControlsBuyLimit } from '../../common/trading-controls-buy/trading-controls-buy-limit'
import { TradingControlsWallet } from '../trading-controls-wallet'

import { TradingControlsBuyAmount } from './trading-controls-buy-amount'

import type { BuyControlsModel } from '../../../atoms/common'
import type { PairModel } from '@root/entities/pair'

type Props = {
  pair: PairModel
  model: BuyControlsModel
}

export const TradingControlsBuyForm: React.FC<Props> = ({ pair, model }) => {
  const [tradeOrderType] = useAtom(tradeOrderTypeAtom)

  return (
    <Root>
      <TradingControlsBuyAmount
        amountInputModel={model.amountInputModel}
        pair={pair}
      />
      {tradeOrderType === 'limit' ? (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
          <TradingControlsBuyLimit model={model} />
        </motion.div>
      ) : undefined}
      <Bottom>
        <TradingControlsWallet pair={pair} />
        <TradingControlsBuyButton
          css={css`
            grid-column: button;
          `}
          pair={pair}
          model={model}
        />
      </Bottom>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
`

const Bottom = styled.div`
  display: grid;
  grid-template-columns: [wallet] auto [button] minmax(0, 1fr);
  align-items: center;
  padding-inline: 10px;
  padding-top: 8px;
  gap: 6px;
`
